import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function CallDashboardMetric({
  icon: Icon,
  label,
  value,
  isLoading,
  formatValue,
}) {
  const displayed = isLoading ? "--" : formatValue ? formatValue(value) : value;

  return (
    <Card size="sm" className="tw:flex-1 tw:min-w-0">
      <CardContent className="tw:flex tw:items-center tw:gap-3">
        {isLoading ? (
          <Skeleton className="tw:size-6  tw:shrink-0 tw:rounded-full" />
        ) : (
          <Icon className="tw:size-6 tw:text-muted-foreground tw:shrink-0" />
        )}
        <div className="tw:flex tw:flex-col tw:min-w-0">
          <span className="tw:text-xs tw:text-muted-foreground tw:truncate">
            {label}
          </span>
          <span className="tw:font-heading tw:text-2xl tw:font-semibold">
            {displayed}
          </span>
        </div>
      </CardContent>
    </Card>
  );
}
